import { ChakraProps, ColorProps, Flex, Text, TypographyProps } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

type TProps = {
    text: string;
    linkText: string;
    href: string;
    fontSize?: TypographyProps['fontSize'];
    color?: ColorProps['color'];
    sx?: ChakraProps['sx'];
};

const TextWithLink = ({ text, linkText, href, fontSize = 'md', color = 'gray.500', sx }: TProps) => (
    <Flex flexDirection="column" justifyContent="center" alignItems="start" maxW="100%" sx={sx}>
        <Text color={color} fontWeight="500" fontSize={fontSize}>
            {text}
            <NavLink to={href}>
                <Text color="brand.500" as="span" ms="5px" fontWeight="500">
                    {linkText}
                </Text>
            </NavLink>
        </Text>
    </Flex>
);

export default TextWithLink;
